module.exports = __webpack_public_path__ + "eb0c60c024f1014e0b3e922afff7d5e1.jpg";